// extracted by mini-css-extract-plugin
export default {"container":"newFeedback_container__xZyrH","header":"newFeedback_header__I-XAm","body":"newFeedback_body__sThHO","congrats":"newFeedback_congrats__uS4Xj"};